module.exports = {
  getDecodedString(str) {
  try {
    str = decodeURI(str);
    return String(str)
      .replace(/&amp;/g, '&')
      .replace(/&#38;/g, '&')

      .replace(/&lt;/g, '<')
      .replace(/&#60;/g, '<')

      .replace(/&gt;/g, '>')
      .replace(/&#61;/g, '>')

      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')

      .replace(/&apos;/g, "'")
      .replace(/&#39;/g, "'")

      .replace(/&sol;/g, '/')
      .replace(/&#47;/g, '/');
    } catch (error) {
      console.error('Error decoding string:', error);
      return str;
    }
  },

  getEncodedString(str = '') {
    return String(str)
      .replace(/&/g, '&amp;')

      .replace(/</g, '&lt;')

      .replace(/>/g, '&gt;')

      .replace(/"/g, '&quot;')

      .replace(/'/g, '&apos;')

      .replace(/\//g, '&sol;');
  }
};
